import { Button, Form } from 'antd';
import { UploadFile } from 'antd/lib';
import { FileUseCaseInterface } from 'application/usecases/FileUseCase';
import { FileEntity } from 'domain/entities/FileEntity';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { Rule } from 'rc-field-form/lib/interface';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import UploadImage from './component/Upload';
interface props {
    fileUseCase: FileUseCaseInterface;
}
export const CU004301Page = ({ fileUseCase }: props) => {
    const dispatch = useAppDispatch();
    const { settlementId } = useParams();
    const [form] = Form.useForm();
    const [files, setFiles] = useState<UploadFile[]>([]);
    const [initFiles, setInitFiles] = useState<UploadFile[]>([]);
    const [isDisable, setIsDisable] = useState(true);
    useEffect(() => {
        if (settlementId) {
            getFiles();
        }
    }, [settlementId]);
    const submit = async (value: any) => {
        const fileEdits = form.getFieldValue('isEdit');
        if (value.image || fileEdits) {
            const fileList = value?.image?.fileList
                ?.filter((item: any) => {
                    return item.originFileObj;
                })
                .map((item: any) => {
                    return item.originFileObj;
                });
            const isEdit: any = fileEdits
                ? fileEdits
                      ?.filter((item: any) => {
                          return files.find((e) => e.uid.includes(item));
                      })
                      .map((item: any) => {
                          const key = `attachmentFile${files
                              .find((e) => e.uid.includes(item))
                              ?.uid.split('_')
                              .at(1)}FileSetId`;
                          return {
                              [key]: item.split('_').at(0),
                          };
                      })
                : [];
            const payload: FileEntity = {
                files: fileList || [],
                isEdit: JSON.stringify(isEdit) || '[]',
                settlementId: settlementId || '',
            };
            try {
                dispatch(startFetching());
                const response = await fileUseCase.uploadFile(payload);
                if (response.status == 200) {
                    openSuccessNoti({ description: '一括返済計算書の登録が完了しました。' });
                }
                getFiles();
                form.setFieldValue('image', '');
                form.setFieldValue('isEdit', '');
            } catch (error) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        }
    };
    const getFiles = async () => {
        if (settlementId) {
            try {
                dispatch(startFetching());
                const files: any = await fileUseCase.getFiles(Number(settlementId));
                const initFiles: UploadFile[] = [];
                for (let i = 1; i <= 10; i++) {
                    if (files.result[`idFile${String(i).padStart(2, '0')}`]) {
                        const url = files.result[`pathFile${String(i).padStart(2, '0')}`];
                        initFiles.push({
                            uid: `${files.result[`attachmentFile${String(i).padStart(2, '0')}FileSetId`]}_${String(i).padStart(2, '0')}`,
                            url: url,
                            status: 'done',
                            name: decodeURI(
                                url.substring(url.lastIndexOf('/') + 1, url.indexOf('?')),
                            ),
                        });
                    }
                }
                setIsDisable(initFiles.length === 0);
                setFiles(initFiles);
                setInitFiles(initFiles);
            } catch (error) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        }
    };
    const validateRules: Rule[] = [
        {
            min: 3,
            max: 100,
            message: '物件は3文字以上、100文字以下で入力してください。',
        },
    ];
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="cu-043-01"
        >
            <PageTitle title="一括返済計算書の登録" />
            <Form
                className="width-full-screen center-inside CU-001-04-container pr-40"
                style={{
                    height: '100vh',
                }}
                onFinish={submit}
                form={form}
            >
                <div style={{ width: 343 }}>
                    <section style={{ width: '100%', marginBottom: 11 }}>
                        <UploadImage form={form} initFile={initFiles} setIsDisable={setIsDisable} />
                    </section>

                    <Button
                        className="button-login-text"
                        type="primary"
                        style={{ width: '100%', height: 56, letterSpacing: -1.5 }}
                        htmlType="submit"
                        disabled={isDisable}
                    >
                        登録する
                    </Button>
                </div>
            </Form>
        </div>
    );
};
